module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tricia Rayburn\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Tricia Rayburn")]), _vm._v(" lives on eastern Long island with her fiancé and crazy shih tzu. She tries to eat vegetables instead of candy but, in her weaker moments, loves Reese's Pieces. "), _c('I', [_vm._v("The Melting of Maggie Bean")]), _vm._v(" is her first novel.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/K1PHPF/tc-custom/9781439155912.jpg?1730490453893",
      "alt": "This image is the cover for the book Maggie Bean in Love"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Maggie Bean in Love\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("At the start of 8th grade, Maggie Bean is really, truly, 100% happy. She's successfully maintained her weight, moved into a beautiful house her family actually owns, and -- best of all -- fallen in love. That's right--love. The real kind, with actual dates, hand holding, laughing and wishing every perfect moment would never end. Maggie wants nothing more than to bask in the joy of having a boyfriend, being a girlfriend and enjoying eighth grade. But eighth grade is serious -- it's one year closer to high school, college and the rest of her life, and Maggie has a lot to do: academic clubs, the swim team, the Patrol This weight-loss club... On top of that, she is striving to the best friend, daughter, and sister she can be (not to mention girlfriend). Balancing everything requires a lot of careful planning and organizing--and, this time, Maggie's Master Mult-Tasker might not be enough. Can she handle the pressure? Can she be everything to everybody--including herself? And will her new relationship survive while she's figuring it all out?")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Aladdin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0